import React from "react";
import { getClassNameFactory } from "../../utilities";
import { uniqueId } from "lodash";
import { types } from "../../elements/Heading";
import { ButtonKind } from "../../elements/Button";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import { Expandable } from "../index";
import { Heading } from "../../elements";
import { Rank } from "../../core";
export var Accordion = function Accordion(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      isExpanded = _ref.isExpanded,
      id = _ref.id,
      expandDisabled = _ref.expandDisabled,
      onHeaderClick = _ref.onHeaderClick,
      children = _ref.children,
      _ref$useAltHeader = _ref.useAltHeader,
      useAltHeader = _ref$useAltHeader === void 0 ? false : _ref$useAltHeader,
      legend = _ref.legend;
  var getClassName = getClassNameFactory(Accordion.displayName);
  var titleClassName = getClassName({
    descendantName: "title"
  });
  var subTitleClassName = getClassName({
    descendantName: "subTitle"
  });
  var regionClassName = getClassName({
    descendantName: "region"
  });
  var headerClassName = getClassName({
    descendantName: "header"
  });
  var headerContainer = getClassName({
    descendantName: "headerContainer"
  });
  var containerWrapper = getClassName({
    descendantName: "containerWrapper"
  });
  var titleContainer = getClassName({
    descendantName: "titleContainer"
  });
  var legendClass = getClassName({
    descendantName: "legendClass"
  });
  var chevronClassName = getClassName({
    descendantName: "icon"
  });
  var containerClassName = getClassName();
  var headerId = uniqueId("Accordion-header-");
  var regionId = uniqueId("Accordion-region-");
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/React.createElement(Expandable, {
    id: id,
    isExpanded: isExpanded,
    onChange: onHeaderClick,
    header: function header(_ref2) {
      var isHeaderExpanded = _ref2.isExpanded,
          onClick = _ref2.onClick;
      return /*#__PURE__*/React.createElement("button", {
        onClick: onClick,
        "aria-controls": regionId,
        id: headerId,
        "aria-disabled": expandDisabled,
        "aria-expanded": isHeaderExpanded,
        "aria-labelledby": headerId,
        className: headerClassName,
        disabled: expandDisabled,
        type: ButtonKind.BUTTON
      }, useAltHeader ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: headerContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: titleContainer
      }, /*#__PURE__*/React.createElement(Heading, {
        rank: Rank.Third,
        type: types.Small,
        className: titleClassName
      }, title), /*#__PURE__*/React.createElement("p", {
        className: subTitleClassName
      }, subTitle)), /*#__PURE__*/React.createElement("div", {
        className: chevronClassName
      }, isHeaderExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
        width: 26
      }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
        width: 26
      }))), legend && /*#__PURE__*/React.createElement("legend", {
        className: legendClass
      }, legend)) : /*#__PURE__*/React.createElement("div", {
        className: containerWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: titleContainer
      }, /*#__PURE__*/React.createElement(Heading, {
        rank: Rank.Third,
        type: types.Small,
        className: titleClassName
      }, /*#__PURE__*/React.createElement("strong", null, title)), /*#__PURE__*/React.createElement("p", {
        className: subTitleClassName
      }, subTitle)), /*#__PURE__*/React.createElement("div", {
        className: chevronClassName
      }, isHeaderExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
        width: 26
      }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
        width: 26
      }))));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: regionClassName,
    id: regionId,
    role: "region",
    "aria-labelledby": headerId
  }, children)));
};
Accordion.displayName = "Accordion";